<!--
* @Name：综合类认定申请审批基础信息
* @Author: 王超
* @Date: 2024-12-16
-->
<template>
  <div>
    <hi-cell title="申请单号：" :value="headInfo.applyCode"></hi-cell>
    <hi-cell title="申请人：" :value="headInfo.crtUserName"></hi-cell>
    <hi-cell title="采购组织：" :value="headInfo.purorgName"></hi-cell>
    <hi-cell title="合作领域：" :value="headInfo.cooperationDomain" :options="cooperationDomainOptions"></hi-cell>
    <hi-cell title="申请原因：" :value="headInfo.applyReasonType" :options="applyReasonTypeOptions"></hi-cell>
    <hi-cell title="结果适用公司：" :value="headInfo.suitableCorpName"></hi-cell>
    <hi-cell title="申请标题：" :value="headInfo.applyTitle"></hi-cell>
    <hi-cell title="申请原因描述：" :value="headInfo.applyReasonDesc"></hi-cell>
  </div>
</template>

<script>
export default {
  name: 'BaseInfo',
  components: {},
  data() {
    return {}
  },
  props: {
    // 基础信息数据
    headInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    // 合作领域参照
    cooperationDomainOptions() {
      return this.$store.getters.dicts.cooperation_domain
    },
    // 申请原因参照
    applyReasonTypeOptions() {
      return this.$store.getters.dicts.willing_to_apply
    }
  }
}
</script>
